import React, { FC, useState, useEffect } from "react";
import { withProcedureWraper } from "../..";
import { Box } from "../../../../components/box";
import { Button, Col, Container, Row } from "react-bootstrap";
import FontFa from "../../../../components/fontFa/fontFa";
import { useSelector } from "../../../../store/store";
import { checkingAcessToken } from "../../../../helper/util";
import WarningDeleteModal from "../../../../modals/warning-delete-modal";
import CreateGroupModal from "../modal/create-group-modal";
import { checkLoggingStatus } from "../../../../constants/statusConstants";
import { TreeState, TreeTable } from "cp-react-tree-table";
import AddUserModal from "../modal/add-user-modal";
import { GroupsOfficeService } from "../../../../services/group365/groupOffice.service";
import { CreateNotification } from "../../../../components/notifier";

export const SettingGroupPage: FC = withProcedureWraper(() => {
  const user = useSelector((state) => state.user);
  const mainState = useSelector((state) => state.main);
  const [currentData, setCurrentData] = useState<any>();
  const [openEditGroupDetailModal, setOpenEditGroupDetailModal] = useState(false);
  const [showDeletedConfirm, setShowDeletedConfirm] = useState(false);
  const [openAddUserModal, setOpenAddUserModal] = useState(false);

  const [deleteTitle, setDeleteTitle] = useState("");
  const [deleteMessage, setDeleteMessage] = useState("");
  const [groups, setGroups] = useState<any>();
  const [member, setMember] = useState<any>([]);

  const getData = () => {
    GroupsOfficeService.getGroups("QLTL")
      .then((data) => {
        let treeData: any = [];
        if (data.length > 0) {
          data.forEach((p: any) => {
            let item: any = p;
            treeData.push({
              data: item,
            });
          });
        }
        if (treeData.length > 0) {
          const temp = TreeState.create(treeData);
          setGroups(TreeState.expandAll(temp));
        } else {
          setGroups(TreeState.createEmpty());
        }
      })
      .catch((error) => {
        CreateNotification({
          title: "Thông báo",
          body: "Không thể lấy nội dung nhóm, vui lòng thử lại",
          icon: "/icons/error.png",
        });
        console.log(error);
      });
  };

  const handleDeleteData = async (data: any) => {
    const result = await GroupsOfficeService.deleteGroup(data.id);
    if (result)
      CreateNotification({
        title: "Xóa nhóm thành công",
        body: "Yêu cầu xóa nhóm của bạn đã được thực hiện",
        icon: "/icons/success.png",
      });
    await getData();
  };

  const toggleDeleteConfirmDialog = () => {
    setShowDeletedConfirm(!showDeletedConfirm);
  };

  const onSaveComplete = async () => {
    await getData();
  };

  const handleShowDetailForm = (row: any, parentRow: any) => {
    let data: any = null;
    if (!row) {
      data = {
        name: parentRow?.data?.name,
      };
    } else {
      data = row.data;
    }
    setCurrentData(data);
    setOpenEditGroupDetailModal(!openEditGroupDetailModal);
  };

  const handleShowAddForm = async (row: any) => {
    if (row?.data) {
      let data: any = null;
      data = row.data;
      setCurrentData(data);
      await GroupsOfficeService.getMemberInGroup(data.id).then((data) => {
        if (data.length > 0) setMember(data);
        else setMember(null);
      });
    }
    setOpenAddUserModal(!openAddUserModal);
  };

  const toggleEditDepartmentDetailModal = () => {
    setOpenEditGroupDetailModal(!openEditGroupDetailModal);
  };

  const handleDeleteConfirmDialog = async (row: any) => {
    setCurrentData(row.data);
    setDeleteTitle("Xóa nhóm");
    let message = `Anh/Chị có muốn xóa nhóm '${row.data.displayName}' và những thành viên trong nhóm không?`;
    setDeleteMessage(message);
    setShowDeletedConfirm(true);
  };

  const renderTitleEditableCell = (row: any) => {
    return (
      <div>
        <span>{row.data.displayName}</span>
      </div>
    );
  };

  const renderDescriptionEditableCell = (row: any) => {
    return <span>{row.data.description}</span>;
  };

  const renderEmailGroupCell = (row: any) => {
    return <span>{row.data.mail}</span>;
  };

  const renderActionEditableCell = (row: any) => {
    return (
      <div className="document-action d-flex border-left">
        <Button
          title="Thêm thành viên"
          onClick={(e) => {
            e.stopPropagation();
            handleShowAddForm(row);
          }}
          className="mr-2 text-success"
          variant="outline"
        >
          <FontFa name="faUserCheck" size="sm" />
        </Button>
        <Button
          title="Chỉnh sửa"
          onClick={(e) => {
            e.stopPropagation();
            handleShowDetailForm(row, null);
          }}
          className="mr-2 text-info"
          variant="outline"
        >
          <FontFa name="faEdit" size="sm" />
        </Button>
        <Button
          title="Xóa"
          onClick={(e) => {
            e.stopPropagation();
            handleDeleteConfirmDialog(row);
          }}
          className="mr-2 text-danger"
          variant="outline"
        >
          <FontFa name="faTrash" size="sm" />
        </Button>
      </div>
    );
  };

  useEffect(() => {
    if (checkingAcessToken(user, mainState) !== checkLoggingStatus.OK) {
      return;
    }

    if (groups) return;

    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mainState.isExpiredToken, mainState.isUnauthorized]);

  return (
    groups && (
      <>
        <div className="ProcedureTrainingPlanPage">
          <div className="pd15">
            <div className="d-flex p-3 justify-content-center">
              <h3>
                <br />
              </h3>
            </div>
            <Box
              title={"Quản lý nhóm thành viên"}
              titleRight={
                <div className="px-4 py-2 d-flex align-items-center">
                  <Button
                    className="mr-2 button-info"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleShowDetailForm(null, null);
                    }}
                    variant="info"
                  >
                    {"Thêm nhóm thành viên"}
                  </Button>
                </div>
              }
            >
              <Container>
                <Row>
                  <Col xs={12} sm={12}></Col>
                </Row>
                <Row>
                  <Col xs={12} sm={12}>
                    <TreeTable value={groups}>
                      <TreeTable.Column
                        renderCell={renderTitleEditableCell}
                        renderHeaderCell={() => <span>Tên nhóm</span>}
                        basis="300px"
                        grow={0}
                      />
                      <TreeTable.Column
                        renderCell={renderDescriptionEditableCell}
                        renderHeaderCell={() => <span>Mô tả</span>}
                        basis="170px"
                      />
                      <TreeTable.Column
                        renderCell={renderEmailGroupCell}
                        renderHeaderCell={() => <span>Email nhóm</span>}
                        basis="100px"
                      />
                      <TreeTable.Column renderCell={renderActionEditableCell} renderHeaderCell={() => <span></span>} />
                    </TreeTable>
                  </Col>
                </Row>
              </Container>
            </Box>
            <CreateGroupModal
              onClose={toggleEditDepartmentDetailModal}
              isOpen={openEditGroupDetailModal}
              data={currentData}
              onSaveComplete={onSaveComplete}
            />
            <AddUserModal
              onClose={handleShowAddForm}
              isOpen={openAddUserModal}
              data={currentData}
              onSaveComplete={onSaveComplete}
              member={member}
            />
            <WarningDeleteModal
              data={currentData}
              title={deleteTitle}
              message={deleteMessage}
              isOpen={showDeletedConfirm}
              onDelete={handleDeleteData}
              onClose={toggleDeleteConfirmDialog}
              basis="180px"
            />
          </div>
        </div>
      </>
    )
  );
});
